module.exports = __webpack_public_path__ + "static/media/party-catering-hero.b2c650df.jpg";